export function projectSlider() {   
    const sliders = document.querySelectorAll('.project-slider');

    sliders.forEach((slider) => {
        new Flickity(slider, {
            cellAlign: 'center',
            contain: false,
            draggable: true,
            pageDots: false,
            autoPlay: true,
            prevNextButtons: true,
            wrapAround: true,
            accessibility: true,
            groupCells: true,
            freeScroll: false,
            adaptiveHeight: true
        });
    });
}
